import { createClient } from '@supabase/supabase-js';

// Usar solo variables de entorno para las credenciales
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Verificar que las variables de entorno estén definidas
if (!supabaseUrl || !supabaseAnonKey) {
  console.error('Error: Supabase environment variables are missing.');
  console.error('Please make sure REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY are defined in your .env file.');
}

// Configuración personalizada para el cliente de Supabase
const supabaseOptions = {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    storage: window.localStorage
  },
  global: {
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
    },
  },
  // Asegurar que las solicitudes CORS se manejen correctamente
  realtime: {
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
    },
  }
};

const supabase = createClient(supabaseUrl, supabaseAnonKey, supabaseOptions);

// Función de ayuda para limpiar el almacenamiento local relacionado con Supabase
export const clearSupabaseStorage = () => {
  // Limpiar tokens específicos
  localStorage.removeItem('supabase.auth.token');
  localStorage.removeItem('sb-refresh-token');
  localStorage.removeItem('sb-access-token');
  
  // Limpiar todos los elementos relacionados con supabase
  Object.keys(localStorage).forEach(key => {
    if (key.startsWith('sb-') || key.includes('supabase')) {
      localStorage.removeItem(key);
    }
  });
};

export default supabase;
